import { useAuth as useAuthContext } from '../contexts/AuthContext.jsx';

/**
 * Custom hook for authentication
 * Re-exports the useAuth hook from AuthContext for easier imports
 */
export const useAuth = useAuthContext;

export default useAuth;
